import { IResPisTpsType } from "../types/data.interface";

export const formatTpsTypeIntoOption = (item: IResPisTpsType) => ({
  value: item,
  label: `${item.res_pis_type_id} - ${item.name}`,
});

export const getTpsTypes = (tpsTypes: IResPisTpsType[]) =>
  tpsTypes.map(formatTpsTypeIntoOption);
